webpackJsonp([269232013120207],{

/***/ 370:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Sunny Crest","author":"Brian Capouch"}},"mongodbOsconBlogposts":{"id":"5b3c12611a7d792030b15b07","path":"/entrance/","post":{"childMarkdownRemark":{"html":"<p>Originally there were six columns separating Sunny Crest from the road to the east: two on either side of the driveway entrances, and two in the center, at either side of the central sidewalk.</p>\n<p>Over time the brick deteriorated and wasn't maintained.  Sometime long ago the columns in the middle were removed, and the refuse deposited along the fence along the west boundary of the homestead.</p>\n<p>More recently, three of the remaining four became unstanble, and were removed.  They repose today at the southwest corner of the house, in a pile.</p>\n<p><img src=\"./IMAGES/entranceCol.jpg\" alt=\"Entrance Column\"></p>","frontmatter":{"title":"Entrance Columns"}}}}},"pathContext":{"id":"5b3c12611a7d792030b15b07"}}

/***/ })

});


// WEBPACK FOOTER //
// path---entrance-181a52016294cf067be1.js